module.exports = __webpack_public_path__ + "img/20190702160737QQ截图20190702020555.6ef4e4f7.png";